import listActions from 'src/modules/quizQuestion/list/quizQuestionListActions';
import QuizQuestionService from 'src/modules/quizQuestion/quizQuestionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'QUIZ_QUESTION_UNARCHIVE';

const quizQuestionUnarchiveActions = {
  UNARCHIVE_STARTED: `${prefix}_UNARCHIVE_STARTED`,
  UNARCHIVE_SUCCESS: `${prefix}_UNARCHIVE_SUCCESS`,
  UNARCHIVE_ERROR: `${prefix}_UNARCHIVE_ERROR`,

  UNARCHIVE_ALL_STARTED: `${prefix}_UNARCHIVE_ALL_STARTED`,
  UNARCHIVE_ALL_SUCCESS: `${prefix}_UNARCHIVE_ALL_SUCCESS`,
  UNARCHIVE_ALL_ERROR: `${prefix}_UNARCHIVE_ALL_ERROR`,

  doUnarchive: (id) => async (dispatch) => {
    try {
      dispatch({
        type: quizQuestionUnarchiveActions.UNARCHIVE_STARTED,
      });

      await QuizQuestionService.unarchiveAll([id]);

      dispatch({
        type: quizQuestionUnarchiveActions.UNARCHIVE_SUCCESS,
      });

      Message.success(
        i18n('entities.quizQuestion.unarchive.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/quiz-question');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: quizQuestionUnarchiveActions.UNARCHIVE_ERROR,
      });
    }
  },

  doUnarchiveAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type:
          quizQuestionUnarchiveActions.UNARCHIVE_ALL_STARTED,
      });

      await QuizQuestionService.unarchiveAll(ids);

      dispatch({
        type:
          quizQuestionUnarchiveActions.UNARCHIVE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.quizQuestion.unarchiveAll.success'),
      );

      getHistory().push('/quiz-question');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type:
          quizQuestionUnarchiveActions.UNARCHIVE_ALL_ERROR,
      });
    }
  },
};

export default quizQuestionUnarchiveActions;
